<app-modal class="lifecycle-modal">
    <ng-container modal-header>
        <h5 class="modal-title">{{ 'admin.tools.details.detailsPage.modals.toolDescriptionModal.title' | translate }}</h5>
    </ng-container>
    <ng-container modal-body>
        <app-loading-spinner *ngIf="isLoading" class="loading-animation"></app-loading-spinner>
        <app-description-form
            *ngIf="tool && !isLoading"
            [owners]="owners"
            [tool]="tool"
            [showValidations]="showValidations">
        </app-description-form>
    </ng-container>
    <div class="footer" modal-footer>
        <app-button type="simple"
                    [disabled]="isLoading"
                    (click)="close()">{{ 'generic.buttons.close' | translate }}
        </app-button>
        <app-button type="primary"
                    [disabled]="isLoading"
                    (click)="clickUpdate()">
            {{ 'generic.buttons.update'| translate }}
        </app-button>
    </div>
</app-modal>
